import * as React from "react";
const SvgTasks20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4 4.5h1.8A2.75 2.75 0 0 0 8.25 6h3.5a2.75 2.75 0 0 0 2.45-1.5H16v13H4v-13Zm14-2h-3.604a2.751 2.751 0 0 0-2.646-2h-3.5a2.75 2.75 0 0 0-2.646 2H2v17h16v-17Zm-9.75 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5ZM9 14.914l4.707-4.707-1.414-1.414L9 12.086l-1.293-1.293-1.414 1.414L9 14.914Z",
      clipRule: "evenodd"
    })
  );
export default SvgTasks20Px;
